<template>
	<span class="_icon" :data-name="transformedName">
		<component :is="componentName" v-if="componentName" class="w-full h-full" />
	</span>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export const names = [
	'none',
	'arrow-up',
	'burocratik',
	'beer',
	'clef',
	'close',
	'coffee',
	'energy',
	'exploding-head',
	'face-expressionless',
	'face-fear',
	'face-grinning-smiling-eyes',
	'face-halo',
	'face-heart-eyes',
	'face-sleepy',
	'face-star-eyes',
	'face-sunglasses',
	'face-tears-joy',
	'face-raised-eyebrow',
	'face-winking',
	'fire',
	'gaming',
	'grinning-face-horns',
	'hands-fist',
	'hands-horns',
	'hands-index-pointing-right',
	'hands-love-you-gesture',
	'hands-middle-finger',
	'hands-pray',
	'hands-raised',
	'hands-thumbs-up',
	'hands-victory-1',
	'hands-victory',
	'hands-vulcan-salute',
	'heart',
	'pause',
	'pin',
	'play',
	'poo',
	'popcorn',
	'skull-evil',
	'skull',
	'smiling-face-horns',
	'trophy',
	'volume-off',
	'volume-up',
	'eyes',
]

const iconModules = import.meta.glob('../../../assets/icons/*.svg')
const files = names.reduce((acc, name) => {
	const loader = iconModules[`../../../assets/icons/${name}.svg`]

	if (loader) {
		acc[name] = defineAsyncComponent(loader)
	}

	return acc
}, {})

export default {
	components: files,
	props: {
		name: {
			type: String,
			required: true,
		},
	},
	computed: {
		transformedName() {
			if (this.name === 'icon-none') return 'none'
			return names.includes(this.name) ? this.name : 'burocratik'
		},
		componentName() {
			return files[this.transformedName] ? this.transformedName : null
		},
	},
}
</script>

<style>
._icon {
	display: inline-block;
	width: var(--size, 24px);
	height: var(--size, 24px);
}

._icon svg {
	display: block;
}

._icon svg [data-svg-fill] {
	fill: var(--color, black);
}

._icon svg [data-svg-stroke] {
	stroke: var(--color, black);
}
</style>
